// Copyright (c) 2026 Chain Capital Technologies Ltd. All rights reserved.
// See LICENSE file in the project root for full license information.

// MUST be the first import. The lazy device/Web3Auth chunks pull deps
// (ledger-bitcoin, @ledgerhq/hw-transport-webhid) that reference the Node
// `Buffer` global at MODULE-EVAL time (e.g. ledger-bitcoin's psbtv2.js
// `Buffer.from(...)`). Browsers have no global `Buffer`, so those module
// bodies throw `Cannot read properties of undefined (reading 'from'/'alloc')`
// the instant their chunk loads. A side-effect import inside those lazy
// chunks does NOT fix it (ESM hoists a chunk's static imports above any
// inlined polyfill statement). Front-loading here, in the entry, is airtight —
// the device chunk is only ever reached via runtime `import()`, strictly
// after this entry has fully evaluated and set the global. The device stack
// stays out of the entry (this only pulls the small `buffer` package).
import './node-polyfills.js';
import { render } from 'preact';
import { App } from './app.js';

render(<App />, document.getElementById('app')!);
